






































































import Vue from "vue";
import Component from "vue-class-component";
import AddFeatureDialog from "../dialogs/AddFeatureDialog.vue";
import { features } from "@/store";
import { IMobilePlatformUpdate } from "@/store/features/models";

interface IHeaders {
  text: string;
  align?: string;
  value: string;
  sortable?: boolean;
}

@Component({
  components: {
    AddFeatureDialog,
  },
})
export default class FeaturesTable extends Vue {
  selectedId: number = 0;
  selectedPlatform: IMobilePlatformUpdate | null = null;
  dialogDelete: boolean = false;
  activateDialog: boolean = false;
  loadError: boolean = false;
  search: string = "";
  headers: IHeaders[] = [
    { text: "Nombre", align: "start", value: "nombre" },
    { text: "Coordenadas", align: "start", value: "coordenadas" },
    { text: "Última modificación:", value: "modified" },
    { text: "Acciones", value: "actions", sortable: false },
  ];

  //methods
  deleteItem(item: IMobilePlatformUpdate) {
    this.dialogDelete = true;
    this.selectedId = item.id;
  }
  modifyItem(item: IMobilePlatformUpdate) {
    this.selectedPlatform = item;
    this.activateDialog = true;
  }
  async deleteItemConfirm() {
    await features.dispatch("deleteMobilePlatform", this.selectedId);
    this.closeDelete();
  }
  closeDelete() {
    this.selectedId = 0;
    this.dialogDelete = false;
  }
  clearSelectedPlatform() {
    this.selectedId = 0;
    this.selectedPlatform = null;
    this.activateDialog = false;
  }

  //computed
  get mobilePlatformsInfo() {
    return features.getters.getMobilePlatformsinfo;
  }
}
